import { render, staticRenderFns } from "./couponFrame.vue?vue&type=template&id=b459b24c"
import script from "./couponFrame.vue?vue&type=script&lang=js"
export * from "./couponFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports